:host {

    table,
    caption,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td {
        margin: 0;
        padding: 0;
        vertical-align: baseline;
        border: 0;
        font: inherit;
        font-size: 100%;
    }


    ti-card {
        display: flex;
        flex-direction: column;
        // min-width: 968px;
        margin-bottom: 10px;
        height: auto;
        a {
            color: $pl-link-color-primary;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
        @include mix-for-sizes-down(phone)  {
            padding: 0;
        }
    }

    .ti-quick-add-to-cart {
        position: absolute;
        right: 30px;
        top: 5px;
        a {
            color: $polaris-color-teal5;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
        img {
            width: 64px;
            vertical-align: middle;
        }
    }



    .new-badge {
        color: #C00;
        align-self: start;
        font-size: $polaris-font-size-1;
        font-weight: 500;
        text-decoration: none;
        line-height: $polaris-line-height-3;
        margin-right: $polaris-space-2;
    }


    // OPN Snapshot Styles
    .ti-opn-snapshot {
        @include mix-for-sizes-down(phone)  {
            margin: -8px;
        }
        a {
            text-decoration: none;
            color: $polaris-color-teal5;
        }
        &-fixed {
            display: flex;
            flex-direction: column;
            max-width: 470px;
        }
        &-data-sheet {
            display: flex;
            align-items: baseline;
            margin-top: 0;
            margin-bottom: $polaris-space-4;
            >a,
            >span {
                align-items: center;
                display: flex;
                margin-right: $polaris-space-2;
            }
            div {
                display: flex;
            }
            > a {
                margin-right: $polaris-space-2;
            }
            .ti-opn-snapshot-divider {
                display: inline;
                padding: 0 $polaris-space-2 0 0;
            }
            @include mix-for-sizes-up(tablet) {
                margin-top: $polaris-space-1;
                margin-bottom: 0;
            }
        }
        &-view-alternates {
            margin-top: $polaris-space-4;
            margin-bottom: $polaris-space-4;

            @include mix-for-sizes-up(tablet) {
                margin-bottom: 0;
            }

            .ti_p-iconText {
                display: flex;
                align-items: center;
                cursor: pointer;
                appearance: none;
                background: transparent;
                border: 0;
                padding: 0;
                color: $pl-link-color-primary;
                font-size: $polaris-font-size-2;


                &:hover {
                    text-decoration: underline;
                }

                .ti_p-iconText-icon {
                    margin-right: $polaris-space-2;
                }
            }
        }
        &-header {
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
            @include mix-for-sizes-down(phone)  {
                flex-direction: column;
            }
        }

        &-image {
            flex: 0 0 auto;
            width: 75px;
            margin-right: $polaris-space-6;
            @include mix-for-sizes-down(tablet) {
                display: none;
            }
        }
        &-label {
            display: flex;
            flex-wrap: nowrap;
            font-size: $polaris-font-size-1;
            text-transform: uppercase;
            line-height: $polaris-line-height-1;
            margin-bottom: $polaris-space-2;
            color: $polaris-color-grey7;
            &:hover {
                color: $polaris-color-grey7;
            }
        }
        &-part-info {
            display: flex;
            align-items: center;
        }

        &-description {
            font-size: $polaris-font-size-2;
            color: $polaris-color-grey7;
            line-height: $polaris-line-height-2;
        }

        &-part-number {
            font-size: $polaris-font-size-3;
            font-weight: $polaris-font-weight-bold;
            line-height: $polaris-line-height-3;
            margin: 0;
        }

        &-opn-match-details {
            border-top: 1px solid $polaris-color-grey2;
            margin-top: 0;
            @include mix-for-sizes-up(tablet) {
                margin-top: $polaris-space-8;
            }
        }

        &-details-row {
            padding: $polaris-space-6 0;
            border-bottom: 1px solid $polaris-color-grey2;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            @include mix-for-sizes-down(phone)  {
                flex-direction: column;
                padding: $polaris-space-4 0 $polaris-space-2;
            }
        }

        &-details {
            margin-right: $polaris-space-4;
        }

        &-alternate-parts {
            font-size: $polaris-font-size-1;
            margin-bottom: $polaris-space-4;
        }

        &-detail-list {
            padding: 0;
            margin: $polaris-space-1 0;
            list-style: none;
            li {
                padding: $polaris-space-1 0;
                margin: 0;
            }
            .ti-opn-snapshot-detail-list-qty {
                display: flex;
                align-items: baseline;
                flex-wrap: wrap;
                padding: 0;
                > span {
                    padding: $polaris-space-1 $polaris-space-1 $polaris-space-1 0;
                    white-space: nowrap;
                }
                ti-disclosure-list {
                    white-space: nowrap;
                    padding: $polaris-space-1 $polaris-space-1 $polaris-space-1 0;
                }
            }
        }


        &-add-to-cart {
            width: 250px;
            > *,
            ti-button {
                display: block;

            }
            // ti-add-to-cart {
            //     display: flex;
            //     flex-direction: column;
            // }
            ti-form-element {
                margin: 0!important;
            }


            .ti-added-to-cart-custom-reel {
                font-size: $polaris-font-size-2;
                margin-top: $polaris-space-3;
            }
            @include mix-for-sizes-down(phone)  {
                width: 100%;
                margin-top: $polaris-space-4;
            }
        }

        &-product-family-link {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: baseline;
            margin-top: $polaris-space-5;
            a {
                cursor: pointer;
                &:hover {
                    text-decoration: none;
                }
            }
            ti-svg-icon {
                margin-right: $polaris-space-2;
            }
        }

        &-additional-pkg{
            border-bottom: 1px solid $polaris-color-grey2;
            color: $polaris-color-grey8;
            display: block;
            font-size: $polaris-font-size-3;
            font-weight: $polaris-font-weight-bold;
            line-height: $polaris-line-height-3;
            padding: $polaris-space-8 0 $polaris-space-3;
            @include mix-for-sizes-down(tablet) {
                padding: $polaris-space-12 0 $polaris-space-4;
            }
        }
        &-out-of-stock-label {
            font-size: $polaris-font-size-3;
            margin-bottom: $polaris-space-2;
        }
        &-not-available-label {
            font-size: $polaris-font-size-2;
        }
        ti-disclosure-list {
            span[slot="label"] {
                line-height: $polaris-line-height-2;
            }
        }

    }
}
